import { createApp } from 'vue';
import TDesign from 'tdesign-mobile-vue';
import App from './App.vue';
import router from './router';
// 引入组件库的少量全局样式变量
import 'tdesign-mobile-vue/es/style/index.css';
import cloudbase from '@cloudbase/js-sdk';

// 初始化云开发环境
const cloudbaseApp = cloudbase.init({
  env: "cloud1-0gl88yx1944d9f7d",
  clientId: 'AOJ8yAAB0gtjEqkf73E'
});

// 创建Vue应用实例
const app = createApp(App);

// 配置全局属性
app.config.globalProperties.$cloudbase = cloudbaseApp;
app.config.globalProperties.$auth = cloudbaseApp.auth();

 


// 使用插件
app.use(router);
app.use(TDesign);

// 挂载应用
app.mount('#app');